import { useState, useEffect } from 'react';

export function useMatchFilters(allMatches = []) {
  const [displayMatches, setDisplayMatches] = useState([]);
  const [dayFilter, setDayFilter] = useState(null);
  const [clubFilter, setClubFilter] = useState(null);
  
  useEffect(() => {
    if (allMatches.length > 0) {
      clearAllFilters();
    }
  }, [allMatches]);
  const filterByDay = (day) => {
    const filteredMatches = allMatches.filter((match) => match.gameday === day);
    setDisplayMatches(filteredMatches);
    setDayFilter(day);
    setClubFilter(null); 
  };
  const filterByClub = (team) => {
    const filteredMatches = allMatches.filter(
      (match) => match.home_team === team || match.away_team === team,
    );
    setDisplayMatches(filteredMatches);
    setClubFilter(team);
    setDayFilter(null);
  };

  const clearAllFilters = () => {
    setDisplayMatches(allMatches);
    setDayFilter(null);
    setClubFilter(null);
  };
  const isFiltered = dayFilter !== null || clubFilter !== null;


  return {
    // State
    displayMatches,
    dayFilter,
    clubFilter,
    
    // Actions
    filterByDay,
    filterByClub,
    clearAllFilters,
    
    // Computed values
    isFiltered,
    
    // Direct setters 
    setDisplayMatches,
    setDayFilter,
    setClubFilter
  };
};
